import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 12px; /* igual nos dois lados */

  @media (min-width: 768px) {
    padding: 0 16px;
  }
`;
